var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1.0-Home",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.0-Home---ativos",
    transform: "translate(-408.000000, -1515.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Actions-/-Operations-/-chat-/-16",
    transform: "translate(0.000000, 1332.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(408.000000, 182.999230)",
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame_-_24px"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0.001,
    width: 24.0000001,
    height: 24.0000001
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_Icons",
    transform: "translate(1.000000, 3.000000)",
    fill: "#757575",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.998,18.001 L0.998000004,18.001 C0.600000002,18.001 0.240000001,17.7650001 0.0820000003,17.4010001 C-0.0780000003,17.0360001 -0.00600000003,16.6120001 0.266000001,16.3210001 L2.57100001,13.8370001 C1.54000001,12.3930001 0.999000004,10.736 0.999000004,9.001 C0.999000004,4.03800002 5.48500002,0.001 10.999,0.001 C16.5130001,0.001 20.9990001,4.03800002 20.9990001,9.001 C20.9990001,13.9640001 16.5120001,18.001 10.998,18.001 Z M3.29100001,16.001 L10.998,16.001 C15.4090001,16.001 18.998,12.8610001 18.998,9.00100001 C18.998,5.14200002 15.4090001,2.00100001 10.998,2.00100001 C6.58700003,2.00100001 2.99800001,5.14200002 2.99800001,9.00100001 C2.99800001,10.538 3.56600001,12.001 4.64000002,13.2330001 C4.97600002,13.6190001 4.96700002,14.1960001 4.61900002,14.5710001 L3.29100001,16.001 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 6.99800003,
    cy: 9.00100004,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10.998,
    cy: 9.00100004,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 14.9980001,
    cy: 9.00100004,
    r: 1
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.be46f9d53140d53709947a373397f4c7.svg";
export { ForwardRef as ReactComponent };